import { CheckCircle, XCircle } from "lucide-react";

export const GeoVsSeoComparison = () => {
  const comparisons = [
    {
      aspect: "Goal",
      seo: "Rank #1 on Google SERP",
      geo: "Be cited as an authoritative source by AI",
    },
    {
      aspect: "Key Signal",
      seo: "Backlinks and domain authority",
      geo: "Structured data and definitional clarity",
    },
    {
      aspect: "Content Format",
      seo: "Long-form, keyword-optimized",
      geo: "FAQ-style, definitive statements",
    },
    {
      aspect: "Success Metric",
      seo: "Organic traffic and rankings",
      geo: "AI citations and mentions",
    },
    {
      aspect: "Schema Focus",
      seo: "Article, Product, Review",
      geo: "FAQ, HowTo, Dataset, Q&A",
    },
    {
      aspect: "Update Cycle",
      seo: "Algorithm updates (months)",
      geo: "Model training (ongoing)",
    },
    {
      aspect: "Competition",
      seo: "10 blue links",
      geo: "Single AI response with sources",
    },
    {
      aspect: "Content Style",
      seo: "Engaging, narrative",
      geo: "Factual, citable, authoritative",
    },
  ];

  return (
    <section className="py-8 sm:py-12">
      <h2 className="text-2xl sm:text-3xl font-display font-bold text-foreground mb-6">
        SEO vs GEO: Side-by-Side Comparison
      </h2>
      <p className="text-muted-foreground mb-8 max-w-3xl">
        Understanding the differences helps you optimize for both channels without compromising either.
      </p>

      <div className="overflow-x-auto">
        <table className="w-full border-collapse">
          <thead>
            <tr className="border-b border-border">
              <th className="text-left py-4 px-4 text-sm font-semibold text-foreground">Aspect</th>
              <th className="text-left py-4 px-4 text-sm font-semibold text-foreground bg-muted/50">Traditional SEO</th>
              <th className="text-left py-4 px-4 text-sm font-semibold text-primary bg-primary/5">GEO (AI Search)</th>
            </tr>
          </thead>
          <tbody>
            {comparisons.map((row, index) => (
              <tr key={index} className="border-b border-border hover:bg-muted/30 transition-colors">
                <td className="py-4 px-4 text-sm font-medium text-foreground">{row.aspect}</td>
                <td className="py-4 px-4 text-sm text-muted-foreground bg-muted/30">{row.seo}</td>
                <td className="py-4 px-4 text-sm text-foreground bg-primary/5">{row.geo}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
};